module.exports = __webpack_public_path__ + "img/Single.118da885.svg";